import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import useLadyService from "@/services/LadyService";

import "./progressBar.scss";

const ProgressBar = ({ percentage }) => {
  const {
    theme
  } = useLadyService();

  let backgroundColor;
  let textColor;
  let pathColor;
  let trailColor;

  switch (theme) {
    case "dark": {
      backgroundColor = "transparent";
      textColor = "#fff";
      pathColor = "#1ca182";
      trailColor = "transparent";
      break;
    }

    default: {
      backgroundColor = "transparent";
      textColor = "black";
      pathColor = "#0ab8b6";
      trailColor = "transparent";
    }
  }

  return (
    <div className="progress-bar">
      <CircularProgressbar
        value={percentage}
        text={`${percentage}%`}
        background
        styles={buildStyles({
          backgroundColor,
          textColor,
          pathColor,
          trailColor,
        })}
      />
    </div>
  );
};

export default ProgressBar;
